import { SEVERITY_TYPES } from '@LSP/constants';

import { WorkflowMode, WorkflowModeType } from '../../graphqlTypes/enums';
import { DiagnosticsType } from '../queries/git';
import { Entity } from '../types/Entity';

export const isEntityEnabled = (workflowMode?: WorkflowModeType, entityMode?: WorkflowModeType) => {
  return !workflowMode || workflowMode === WorkflowMode.stream || entityMode === WorkflowMode.batch;
};

export const getDiagnosticTypeWithCount = (diagnostics: DiagnosticsType[]) => {
  const errors = diagnostics.filter((diagnostic) => diagnostic.severity === SEVERITY_TYPES.error);
  const warnings = diagnostics.filter((diagnostic) => diagnostic.severity === SEVERITY_TYPES.warning);
  const infos = diagnostics.filter((diagnostic) => diagnostic.severity === SEVERITY_TYPES.info);
  const hints = diagnostics.filter((diagnostic) => diagnostic.severity === SEVERITY_TYPES.hint);
  let overallSeverity = SEVERITY_TYPES.hint;
  if (errors.length > 0) {
    overallSeverity = SEVERITY_TYPES.error;
  } else if (warnings.length > 0) {
    overallSeverity = SEVERITY_TYPES.warning;
  } else if (infos.length > 0) {
    overallSeverity = SEVERITY_TYPES.info;
  }

  return { overallSeverity, warnings, errors, hints };
};
export const delimiter = '$$$$$$$';
export function getFilePathWithoutEntityId(path = '', entityId = '') {
  return path.replace(delimiter + entityId, '');
}

export function getFilePathWithEntityId(path = '', entityId = '') {
  return path + delimiter + entityId;
}

export const getSnapShotEntity = (entity: Entity) => {
  return entity === Entity.Snapshot ? Entity.Model : entity;
};
